import styled from 'styled-components';
import { ModalLeadFormStyled } from '../ModalLeadFormStyled';
import { rem } from 'polished';

export const ModalLeadFormStyledOV = styled(ModalLeadFormStyled)`
    .btn-primary {
        width: 100%;
        text-decoration: none;
        background: ${({ theme }) => theme.colors.primary};
        color: ${({ theme }) => theme.colors.black};

        &:hover,
        &:focus-visible {
            background: ${({ theme }) => theme.colors.black};
            color: ${({ theme }) => theme.colors.white};
        }
    }
    .legal_description {
        font-size: ${({ theme }) => theme.fontSizes.textBase};
        line-height: ${rem(18)};
        margin: ${rem(32)} 0 ${rem(16)} 0;
    }
    .legal_agreement_title {
        font-size: ${rem(16)};
        border: 1px solid ${({ theme }) => theme.colors.grey3};
        padding: ${rem(16)};
        cursor: pointer;
        margin: 0;

        &.isOpen {
            .isOpen {
                display: block;
            }

            .isClose {
                display: none;
            }
        }

        &.isClose {
            .isOpen {
                display: none;
            }

            .isClose {
                display: block;
            }
        }
    }
    .legal_agreement_description {
        font-size: ${({ theme }) => theme.fontSizes.h5};
        padding: ${rem(20)} ${rem(16)} ${rem(20)} ${rem(16)};
        margin-top: -${rem(25)};
        border: 1px solid ${({ theme }) => theme.colors.grey3};
        border-top: none;
    }
    .agreement1 div div,
    .agreement2 div div,
    .agreement3 div div {
        display: flex;
        gap: ${rem(30)};
    }
    .form-field {
        svg {
            width: ${rem(20)};
            height: ${rem(20)};
            position: absolute;
            right: ${rem(16)};
            top: ${rem(12)};

            path {
                fill: ${({ theme }) => theme.colors.black2};
            }
        }
    }

    .form-field h1,
    .form-field h2,
    .form-field h3,
    .form-field h4,
    .form-field h5,
    .form-field h6,
    .form-field p {
        font-family: ${({ theme }) => theme.fonts.fontBase};
        color: ${({ theme }) => theme.colors.black} !important;
    }

    .form-field p > a {
        text-decoration: none;
        color: ${({ theme }) => theme.colors.black} !important;
        font-weight: bold;
    }

    .form-field p > a > b {
        color: inherit;
        font-weight: inherit;
    }

    .form-field p > a:hover {
        text-decoration: underline;
    }

    .radiocheckbox-container {
        input[type='radio']:checked {
            background: ${({ theme }) => theme.colors.primary};
            border-color: ${({ theme }) => theme.colors.primary};

            &::before {
                background-color: ${({ theme }) => theme.colors.black};
                width: ${rem(10)};
                height: ${rem(10)};
                top: ${rem(4)};
                left: ${rem(4)};
            }
        }

        input[type='checkbox']:checked {
            background: ${({ theme }) => theme.colors.primary};
            border-color: ${({ theme }) => theme.colors.primary};

            &::before {
                content: '';
                border: 2px solid;
                border-left: 0;
                border-top: 0;
                height: ${rem(12)};
                left: ${rem(6)};
                position: absolute;
                top: ${rem(2)};
                transform: rotate(45deg);
                transition: opacity 0.2s ease-in-out;
                width: ${rem(6)};
                color: ${({ theme }) => theme.colors.black};
            }
        }
    }
`;
